module.exports = __webpack_public_path__ + "img/Unidad6-3.12157b17.png";